// extracted by mini-css-extract-plugin
module.exports = {"descriptionWrapper":"EmployeeOffDutyStatistic_descriptionWrapper__25hDO"};